import { Box } from "@material-ui/core";
import { useContext } from "react";
import AcademicDegreeComponent from "../../../components/materialui/Shared/AcademicDegreeComponent";
import VocationalTraningComponent from "../../../components/materialui/Shared/VocationalTraningComponent";
import Steps from "../../../../components/steps/Steps";
import { CorpoClinicoContext } from "../../../../context/CorpoClinicoContext";
import FormBase from "../../../../forms/FormBase";
import { AcademicDegreeFormItem } from "../../../../forms/shared/AcademicDegreeForm";
import { VocationalTraningFormItem } from "../../../../forms/shared/VocationalTraningForm";

export default function AcademicDegreeVocationalTraningStep() {

    const { state, dispatch } = useContext(CorpoClinicoContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    const onCrudAcademicDegreeAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', academicDegreeFormItem?: AcademicDegreeFormItem) => {
        dispatch({
            type: "CRUD_FORM_ACADEMIC_DEGREE",
            payload: { subType: subTypeParam, item: academicDegreeFormItem  },
        });
    };

    const onCrudVocationalTraningAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', vocationalTraningFormItem?: VocationalTraningFormItem) => {
        dispatch({
            type: "CRUD_FORM_VOCATION_TRANING",
            payload: { subType: subTypeParam, item: vocationalTraningFormItem  },
        });
    };

    return (
        <div>
            <Steps.StepTitle text="Formação Profissional" />

            <Box mt={2} mb={4}>
                <VocationalTraningComponent 
                    VocationalTraningForm={state.VocationalTraningForm} 
                    onCancelItem={() => { onCrudVocationalTraningAction("Cancel") }}
                    onInserOrUpdateItem={() => { onCrudVocationalTraningAction("InsertOrUpdate") }}
                    onEditClick={(e: VocationalTraningFormItem) => { onCrudVocationalTraningAction("Edit", e) }}
                    onDeleteClick={(e: VocationalTraningFormItem) => { onCrudVocationalTraningAction("Delete", e) }}
                    onInputChange={onInputChange} />
            </Box>

            <Steps.StepTitle text="Títulos Acadêmicos e Cursos" />

            <Box mt={2} mb={4}>
                <AcademicDegreeComponent 
                    AcademicDegreeForm={state.AcademicDegreeForm} 
                    onCancelItem={() => { onCrudAcademicDegreeAction("Cancel") }}
                    onInserOrUpdateItem={() => { onCrudAcademicDegreeAction("InsertOrUpdate") }}
                    onEditClick={(e: AcademicDegreeFormItem) => { onCrudAcademicDegreeAction("Edit", e) }}
                    onDeleteClick={(e: AcademicDegreeFormItem) => { onCrudAcademicDegreeAction("Delete", e) }}
                    onInputChange={onInputChange} />
            </Box>

        </div>
    )
}